import {
    type ViewStyle,
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    BreadcrumbLinkColorsConstantType,
    BreadcrumbLinkDynamicStyleType,
    BreadcrumbLinkColors
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

export const getBreadcrumbLinkColors = ({
    isHighlighted,
    isDisabled,
    colors
}: BreadcrumbLinkColorsConstantType): BreadcrumbLinkColors => {
    if(isDisabled) {
        return {
            titleColor: colors.system.state.content.disabled.neutral,
            iconColor: colors.system.state.content.disabled.neutral,
            iconColorKey: "disabled"
        };
    }

    if(isHighlighted) {
        return {
            titleColor: colors.content.text.high,
            iconColor: colors.content.icon.high,
            iconColorKey: "high"
        };
    }

    return {
        iconColor: colors.content.icon.default,
        titleColor: colors.content.text.mid,
        iconColorKey: "default"
    };
};

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        flexShrink: 1,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    content: {
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 1
    },
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    touchTargets,
    pointerType,
    isIconOnly,
    measures,
    radiuses,
    borders,
    colors,
    spaces
}: BreadcrumbLinkDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: measures.boxHeight,
        touchTargets,
        pointerType
    });

    const styles = {
        title: {
            maxWidth: shapeConfigs.sideListWidth,
            lineHeight: measures.lineHeight
        } as Mutable<TextStyle>,
        surface: {
            paddingHorizontal: spaces.spacingXs,
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            height: measures.boxHeight
        } as Mutable<ViewStyle>,
        container: {
            marginHorizontal: -spaces.spacingXs,
            minHeight: hitArea.minHeight
        } as Mutable<ViewStyle>,
        content: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    if(isIconOnly) {
        delete styles.surface.paddingHorizontal;

        Object.assign(styles.container, {
            marginHorizontal: (measures.iconSize - Math.max(measures.boxHeight, hitArea.minWidth)) / 2,
            minWidth: hitArea.minWidth
        });

        Object.assign(styles.surface, {
            width: measures.boxHeight
        });
    }

    return styles;
};
export default stylesheet;
